import { MockFactory } from '@tino-frontend/mocks'
import { ValidatePaymentLinkResponse } from '@types'

export const validatePaymentLinkValidMock =
  new MockFactory<ValidatePaymentLinkResponse>({
    is_valid: true,
    amount_cents: 500,
    merchant_document_number: 'merchant_document_number_1',
  })
